import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fleetRecordsWithIdAPI } from "../api/procurement";
import {
  fleetRecoveryWithIDAPI,
  fleetRecoveryAllAPI,
  fleetReceiveIDAPI,
  fleetHandoverWithIDAPI,
} from "../api/fleet_management";
import { assignedDriverFleetAPI } from "../api/procurement";
export const filterResponseArrayToObject = async (response, responseArray) => {
  let filtered_reponses = { ...response?.results };
  for (let i = 0; i < responseArray?.length; i++) {
    const temp_filtered = {};
    const temp_docs_records = filtered_reponses?.responseArray[i]?.arrayName;
    for (let j = 0; j < temp_docs_records?.length; j++) {
      const record_name = temp_docs_records[j]?.arrayType;
      temp_filtered[record_name] = { ...temp_docs_records[j] };
    }
    filtered_reponses = {
      ...filtered_reponses,
      [responseArray[i]]: temp_filtered,
    };
  }

  return filtered_reponses;
};

export const formatedObj = {};

// Async thunks for API calls
export const fetchAllTableRecoveryApi = createAsyncThunk(
  "slice/fetchDataFromRecoveryApi",
  async () => {
    try {
      const result = await fleetRecoveryAllAPI();
      return result;
    } catch (error) {
      console.error("Error");
    }
  }
);

export const fetchFleetProcurParkWithId = createAsyncThunk(
  "dashboard/fleet/details",
  async (fleetId) => {
    try {
      const response = await fleetRecordsWithIdAPI(fleetId);
      let filtered_reponses = {};
      const vehicle_filtered = {};
      const vehicle_docs_records = response?.results?.vehicle_docs;
      for (let j = 0; j < vehicle_docs_records?.length; j++) {
        const record_name = vehicle_docs_records[j]?.document_type;
        vehicle_filtered[record_name] = { ...vehicle_docs_records[j] };
      }
      filtered_reponses = {
        ...response?.results,
        vehicle_docs: vehicle_filtered,
      };
      return filtered_reponses;
    } catch (error) {
      return error;
      // throw error
    }
  }
);

export const fetchFleetRecoveryWithID = createAsyncThunk(
  "dashboard/fleet/recoverys",
  async (fleetId) => {
    try {
      const response = await fleetRecoveryWithIDAPI(fleetId);
      return response?.results?.data;
    } catch (error) {
      return error;
      // throw error
    }
  }
);

export const fetchFleetReceiveWithID = createAsyncThunk("dashboard/fleet/receive", async (obj) => {
  try {
    const response = await fleetReceiveIDAPI(obj);
    return response.results;
  } catch (error) {
    console.error("ERROR5", error);
  }
});

export const fetchFleetHandoverWithID = createAsyncThunk("dashboard/fleet/handover", async (id) => {
  try {
    const response = await fleetHandoverWithIDAPI(id);
    return response?.results?.vehicleAssignedRequest;
  } catch (error) {
    console.error("ERROR5", error);
  }
});

export const fetchAssignedDriver = createAsyncThunk(
  "dashboard/fleet/assignedDriver",
  async (fleetId) => {
    try {
      const response = await assignedDriverFleetAPI(fleetId);

      return response?.results[0]?.driver_details;
    } catch (error) {
      console.error("ERROR5", error);
    }
  }
);

const FleetManagemntAllDashboardSlice = createSlice({
  name: "fleetManagementSlice",
  initialState: {
    recovery: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchAllTableRecoveryApi
      .addCase(fetchAllTableRecoveryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllTableRecoveryApi.fulfilled, (state, action) => {
        function getStatusText(text) {
          if (text === "parked") {
            return "Parked (Completed)";
          } else if (text === "no_recovery_required") {
            return "No Recovery Required";
          } else if (text === "recovered") {
            return "Recovered";
          } else if (text === "force_recovery_required") {
            return "Force Recovery Required";
          } else if (text === "police_station") {
            return "Police Station";
          } else if (text === "hm_approved") {
            return "Under Recovery";
          } else if (text === "recovery_failed") {
            return "Recovery Failed";
          } else if (text === "theft") {
            return "Theft";
          } else if (text === "under-recovery") {
            return "Under Recovery";
          } else if (text === "recovery_failed") {
            return "Recovery Failed";
          } else {
            return "Unknown Status"; // Default case if none of the conditions match
          }
        }
        state.recovery = Array.isArray(action?.payload?.results)
          ? action?.payload?.results?.map((record) => {
              const obj = {};
              obj["id"] = record?.id;
              obj["phone"] = record?.Driver?.phone;
              obj["drId"] = record?.Driver?.driver_small_id;
              obj["driverName"] = `${
                record?.Driver?.first_name ? record?.Driver?.first_name : ""
              } ${record?.Driver?.last_name ? record?.Driver?.last_name : ""}`;
              obj["reg_number"] = record?.vehicle?.reg_number;
              obj["vehicleGpsLocation"] = "";
              obj["odometerReading"] = record?.odometer_reading;
              obj["receivedFrom"] = record?.recieve_from;
              obj["idProofOnlyForThirdParty"] = record?.id_proof?.map((item) => item?.imageUrl);
              obj["injuryOnOurSide"] = record?.injury_our_side;
              obj["injuryDetailsOnOurSide"] = record?.injury_details_our_side;
              obj["injuryPicsOnOurSide"] = record?.injury_pics_our_side?.map(
                (item) => item?.imageUrl
              );
              obj["injuryOnDriverSide"] = record?.injury_on_driver_side;
              obj["injuryDetailsOnDriverSide"] = record?.injury_details_driver_side;
              obj["updatedAt"] = record?.updatedAt;
              obj["injuryPicsOnDriverSide"] = record?.injury_pics_driver_side?.map(
                (item) => item?.imageUrl
              );
              obj["vehiclePhoto"] = record?.vehicle_pics?.map((item) => item?.imageUrl);
              obj["fir"] = record?.fir_no;
              obj["status"] = record?.status;
              if (
                record?.status === "parked" ||
                record?.status === "recovered" ||
                record?.status === "no_recovery_required"
              ) {
                obj["statusOnTable"] = getStatusText(record?.status);
              } else {
                obj["statusOnTable"] = getStatusText(record?.recovery_status || record?.status);
              }
              obj["recovery_status"] = record?.recovery_status;
              obj["recoveryStatus"] = record?.recovery_status
                ? record?.recovery_status
                : record?.status;
              obj["firCopy"] = record?.fir_pic?.map((item) => item?.imageUrl);
              obj["tracedThrough"] = record?.traced_through;
              obj["Created_at"] = record?.createdAt;
              obj["receiveName"] = "";
              obj["accessories_present"] = Array.isArray(record.missing_details)
                ? record?.missing_details
                : [];
              // obj["recoveryStatus"] = record.status;
              obj["recoveredLocation"] = `${
                record?.recovered_location_latitude && record?.recovered_location_latitude
              } ${record?.recovered_location_longitude && record?.recovered_location_longitude}`;
              obj["recoveryExpenseOthers"] = record?.recovery_expenses?.find(
                (expense) => expense?.type === "Other"
              )?.amount;
              obj["recoveryExpenseFuelCng"] = record?.recovery_expenses?.find(
                (expense) => expense?.type === "fuel/CNG"
              )?.amount;
              obj["recoveryExpenseToll"] = record?.recovery_expenses?.find(
                (expense) => expense?.type === "Toll"
              )?.amount;
              obj["recovery_agent_remarks"] = record?.recovery_agent_remarks;
              // obj["Updated_at"] = record?.Updated_at;
              obj["recoveryAgentName"] = `${record?.RecoveryAgent?.first_name} ${
                record?.RecoveryAgent?.last_name ? record?.RecoveryAgent?.last_name : ""
              }`; //
              obj["recoveryAgentNumber"] = record?.RecoveryAgent?.phone_number; //
              return obj;
            })
          : [];
      })
      .addCase(fetchAllTableRecoveryApi?.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.error?.message;
      });
  },
});

const fetchFleetRecoverySlice = createSlice({
  name: "fetchFleetRecoverySlice",
  initialState: {
    receive: {},
    receiveUpdated: {},
    handover: {},
    handoverUpdated: {},
    recovery: {},
    recoveryUpdated: {},
    procurement: {},
    procurementUpdated: {},
    parking: {},
    parkingUpdated: {},
    error: null,
    isLoading: false,
    initialHandover: {},
    initialReceive: {},
    initialRecovery: {},
    assignedDriverDetails: {},
    allAssignedDrivers: [],
    fleetIdCurrent: "",
  },
  reducers: {
    getReceive: (state, action) => {
      state.receive = { ...state.receive, ...action.payload };
    },
    updatedReceive: (state, action) => {
      state.receiveUpdated = { ...state.receiveUpdated, ...action.payload };
    },
    getHandover: (state, action) => {
      state.handover = action.payload;
    },
    updatedHandover: (state, action) => {
      state.handoverUpdated = action.payload;
    },
    getRecovery: (state, action) => {
      state.recovery = action.payload;
    },
    updatedRecovery: (state, action) => {
      state.recoveryUpdated = action.payload;
    },
    getProcurement: (state, action) => {
      state.procurement = action.payload;
    },
    updatedProcurement: (state, action) => {
      state.procurementUpdated = action.payload;
    },
    getParking: (state, action) => {
      state.parking = action.payload;
    },
    updatedParking: (state, action) => {
      state.parkingUpdated = action.payload;
    },
  },
  extraReducers: (builder) => {
    //for Receive Hnadover Async thunk handling
    builder
      .addCase(fetchFleetReceiveWithID.pending, (state) => {
        state.isLoading = true;
        state.receiveUpdated = {};
        state.handoverUpdated = {};
        state.recoveryUpdated = {};
      })
      .addCase(fetchFleetReceiveWithID.fulfilled, (state, action) => {
        state.isLoading = false;

        const data1 = action.payload || {};
        const obj = {
          // request_type:
          // request:
          requestType: data1?.request_type,
          id: data1?.request_id,
          driver_small_id: data1?.driver_small_id,
          driver_name: data1?.driver_name,
          driver_id: data1?.driver_id,
          drop_type: data1?.drop_type,
          request_status: data1?.request_status,
          request_vehicle_unassign_pic: Array.isArray(data1?.request_vehicle_unassign_pic)
            ? data1?.request_vehicle_unassign_pic
            : [],
          // recoveryAgentsReportOnMissingItemsOptions:data1.recovery_missing_details,
          request_vehicle_damage_details: data1?.request_vehicle_damage_details,
          maintainance_charge: data1?.approved_maintainance_charge
            ? data1.approved_maintainance_charge
            : data1?.maintainance_charge,
          request_vehicle_unassign_odometer_reading:
            data1?.request_vehicle_unassign_odometer_reading,
          request_vehicle_assign_odometer_reading: data1?.request_vehicle_assign_odometer_reading,
          new_assgined_vehicle_id: data1?.new_assgined_vehicle_id,
          registration_number_new: data1?.registration_number_new,
          request_vehicle_assessories_present: Array.isArray(
            data1?.request_vehicle_assessories_present
          )
            ? data1?.request_vehicle_assessories_present
            : [],
          parking_remarks: data1?.parking_remarks,
          vehicle_status: data1?.vehicle_status,
          scheme_name: data1?.scheme_name,
          request_reason: data1?.request_reason,
          request_remarks: data1?.request_remarks,
          // request_at:`${
          //   data1?.request_at
          //     ? `${new Date(data1.request_at).toLocaleDateString()} [${new Date(
          //         data1.request_at
          //       ).toLocaleTimeString()}]`
          //     : ""
          // }`,
          request_at: data1?.request_at,
          request_closure_at: data1?.request_closure_at,
          vehicle_id: data1?.current_assigned_vehicle,
          recoveryAgentsReportOnMissingItemsOptions: data1?.recovery_missing_details,
          proof_in_case_of_disparity: Array.isArray(data1?.proof_in_case_of_disparity)
            ? data1?.proof_in_case_of_disparity
            : [],
          maintainance_level: data1?.maintainance_level,
        };
        state.receive = obj;
        state.initialReceive = obj;
        state.fleetId = data1?.current_assigned_vehicle;
      })
      .addCase(fetchFleetReceiveWithID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      });

    builder
      .addCase(fetchFleetHandoverWithID.pending, (state) => {
        state.isLoading = true;
        state.receiveUpdated = {};
        state.handoverUpdated = {};
        state.recoveryUpdated = {};
      })
      .addCase(fetchFleetHandoverWithID.fulfilled, (state, action) => {
        state.isLoading = false;
        const data = action?.payload;

        const obj = {
          request_type: data?.status,
          driver_small_id: data?.driver_small_id,
          driver_id: data?.driver_id,
          driver_name: `${data?.first_name} ${data?.last_name ? data?.last_name : ""}`,
          odometer_reading: data?.start_odometer,
          parking_remarks: data?.parking_remarks,
          alternate_vehicle_received: data?.reg_number,
          status: data?.status,
          scheme_name: data?.scheme_name,
          vehicle_id: data?.vehicle_id,
          vehicle_photos: Array.isArray(data?.assign_pics) ? data?.assign_pics : [],
          // created_at:`${
          //   data?.created_at
          //     ? `${new Date(data.created_at).toLocaleDateString()} [${new Date(
          //         data.created_at
          //       ).toLocaleTimeString()}]`
          //     : ""
          // }`,
          created_at: data?.created_at,
          // updated_at:`${
          //   data?.updated_at
          //     ? `${new Date(data.updated_at).toLocaleDateString()} [${new Date(
          //         data.updated_at
          //       ).toLocaleTimeString()}]`
          //     : ""
          // }`,
          updated_at: data?.updated_at,
          pre_inspection_pop_up: data?.pre_inspection_pop_up,
          pre_inspection_reason_pop_up: data?.pre_inspection_reason_pop_up,
          km_left: data?.km_left,
          days_left: data?.days_left,
          is_gps_present: data?.is_gps_present,
        };
        state.handover = obj;
        state.initialHandover = obj;
        state.fleetId = data?.vehicle_id;
      })
      .addCase(fetchFleetHandoverWithID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      });

    //for Recovery Async thunk handling
    builder
      .addCase(fetchFleetRecoveryWithID.pending, (state) => {
        state.isLoading = true;
        state.receiveUpdated = {};
        state.handoverUpdated = {};
        state.recoveryUpdated = {};
      })
      .addCase(fetchFleetRecoveryWithID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoading = false;

        const data = { ...action.payload };
        state.fleetId = data?.vehicle_id;
        const lat = data?.recovered_location_latitude;
        const long = data?.recovered_location_longitude;
        const recovery = {
          drId: data?.Driver?.driver_small_id,
          driverName: `${
            data?.Driver?.first_name ? data?.Driver?.first_name : ""
          } ${data?.Driver?.last_name ? data?.Driver?.last_name : ""}`,
          vehicleId: data?.vehicle_id,
          vehicleGpsLocation: "",
          odometer_reading: data?.odometer_reading,
          recieve_from: data?.recieve_from,
          id_proof: Array.isArray(data?.id_proof) ? data?.id_proof : [],
          injury_our_side: data?.injury_our_side,
          injury_details_our_side: data?.injury_details_our_side,
          injury_pics_our_side: Array.isArray(data.injury_pics_our_side)
            ? data.injury_pics_our_side
            : [],
          injury_on_driver_side: data.injury_on_driver_side,
          injury_details_driver_side: data.injury_details_driver_side,
          injury_pics_driver_side: Array.isArray(data.injury_pics_driver_side)
            ? data.injury_pics_driver_side
            : [],
          vehicle_pics: Array.isArray(data.vehicle_pics) ? data.vehicle_pics : [],
          fir_no: data?.fir_no,
          scheme_name: data?.scheme_name,
          fir_pic: Array.isArray(data.fir_pic) ? data.fir_pic : [],
          traced_through: data.traced_through,
          missing_details: Array.isArray(data.missing_details) ? data.missing_details : [],
          // status:`${getStatusText(data.status === "recovered"
          //     ? "recovered"
          //     : data.recovery_status
          //     ? data.recovery_status
          //     : data.status)
          //     }`,
          status:
            data.status === "recovered"
              ? "recovered"
              : data.recovery_status
                ? data.recovery_status
                : data.status,
          statusHM: data.status,
          recoveredLocation: `${lat && lat !== null ? lat : ""}, ${
            long && long !== null ? long : ""
          }`,
          recoveryExpenseFuelCng: data.recovery_expenses?.find(
            (expense) => expense.type === "fuel/CNG"
          )?.amount,
          recoveryExpenseToll: data.recovery_expenses?.find((expense) => expense.type === "Toll")
            ?.amount,
          recoveryExpenseOthers: data.recovery_expenses?.find((expense) => expense.type === "Other")
            ?.amount,
          recovery_agent_remarks: data.recovery_agent_remarks,
          // createdAt:
          //   `${
          //   data?.createdAt
          //     ? `${new Date(data.createdAt).toLocaleDateString()} [${new Date(
          //         data.createdAt
          //       ).toLocaleTimeString()}]`
          //     : ""
          // }`,
          createdAt: data?.createdAt,
          // updatedAt: `${
          //   data?.updatedAt
          //     ? `${new Date(data.updatedAt).toLocaleDateString()} [${new Date(
          //         data.updatedAt
          //       ).toLocaleTimeString()}]`
          //     : ""
          // }`,
          updatedAt: data?.updatedAt,
        };
        state.recovery = { ...recovery };
        state.initialRecovery = { ...recovery };

        if (state.recovery.recoveredLocation === ", ") {
          state.recovery.recoveredLocation = "";
        }
      })
      .addCase(fetchFleetRecoveryWithID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      });

    //for Procurement and parking Async thunk handling
    builder
      .addCase(fetchFleetProcurParkWithId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchFleetProcurParkWithId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        // state.procurement = action.payload?.vehicle_additional_detail;
        state.fleetIdCurrent = action.payload?.id;
        const { vehicle_additional_detail, vehicle_docs, ...filteredData } = action.payload;
        state.procurement = {
          ...action.payload?.vehicle_additional_detail,
          ...filteredData,
        };
        // state.fleetId = state?.procurement?.id;
        //vehicle docs attributes filteration
        const obj = {};
        const records = action?.payload?.vehicle_docs;
        obj["insuranceNumber"] = records?.Insurance?.document_number;
        obj["insuranceStartDate"] = records?.Insurance?.start_date;
        obj["insuranceEndDate"] = records?.Insurance?.end_date;
        obj["insuranceType"] = records?.Insurance?.company;
        obj["Insurance"] = records?.Insurance?.photos;
        obj["fasttagNumber"] = records?.Fastag?.document_number;
        obj["fastagCompany"] = records?.Fastag?.company;
        obj["Fastag"] = records?.Fastag?.photos;
        obj["pollutionCertificateStartDate"] = records?.PollutionCertificate?.start_date;
        obj["pollutionCertificateEndDate"] = records?.PollutionCertificate?.end_date;
        obj["PollutionCertificate"] = records?.PollutionCertificate?.photos;
        obj["fitnessCertificateEndDate"] = records?.FitnessCertificate?.end_date;
        obj["FitnessCertificate"] = records?.FitnessCertificate?.photos;
        obj["permitNumber"] = records?.Permit?.document_number;
        obj["permitCompany"] = records?.Permit?.company;
        obj["Permit"] = records?.Permit?.photos;
        obj["permitEndDate"] = records?.Permit?.end_date;
        obj["authorisationNumber"] = records?.Authorisation?.document_number;
        obj["authorisationEndDate"] = records?.Authorisation?.end_date;
        obj["Authorisation"] = records?.Authorisation?.photos;
        obj["fleetId"] = action.payload.id;

        state.parking = obj;
        state.tempObjInitialState = {
          ...state.tempObjInitialState,
          ...state.procurement,
          ...state.parking,
          ...state.handoverAndReceive,
          ...state.recovery,
        };
      })
      .addCase(fetchFleetProcurParkWithId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      });
    builder
      .addCase(fetchAssignedDriver.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAssignedDriver.fulfilled, (state, action) => {
        state.isLoading = false;
        let vendorDDArr = [];
        let mainDriver = "";
        let scheme = "";
        const data = action.payload;
        state.allAssignedDrivers = data;

        Array.isArray(data) &&
          data
            ?.filter((obj) => {
              return obj.uber_mapping_status === "active";
            })
            ?.map((object) => {
              if (object.scheme?.toLowerCase()?.includes("vendor")) {
                scheme = "vendor";
                if (!object.secondary_category) {
                  mainDriver = object.name;
                }
                if (object.secondary_category?.includes("VendorB")) {
                  vendorDDArr.push(object.name);
                }
              }
              if (object.scheme === "double driver") {
                scheme = "double driver";
                if (!object.secondary_category) {
                  mainDriver = object.name;
                }
                if (object.secondary_category === "DoubleDriverB") {
                  vendorDDArr.push(object.name);
                }
              }
              if (object.scheme === "Rental") {
                scheme = "Rental";
                mainDriver = object.name;
                vendorDDArr = [];
              }
              if (object.scheme === "ownership - 3yr") {
                scheme = "ownership - 3yr";
                mainDriver = object.name;
                vendorDDArr = [];
              }
              if (object.scheme === "ownership - 4yr") {
                scheme = "ownership - 4yr";
                mainDriver = object.name;
                vendorDDArr = [];
              }
              if (object.scheme === "60-40") {
                scheme = "60-40";
                mainDriver = object.name;
                vendorDDArr = [];
              }
            });
        const assignedDriverObj = {};
        assignedDriverObj["mainDriver"] = mainDriver;
        assignedDriverObj["vendorDDArr"] = vendorDDArr;
        assignedDriverObj["scheme"] = scheme;

        state.assignedDriverDetails = assignedDriverObj;
        // state.assignedDriverDetails = action.payload;
      })
      .addCase(fetchAssignedDriver.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      });
  },
});

// getHandReceive, updatedHandReceive,getRecovery, updatedRecovery, getProcurement, updatedProcurement, getParking, updatedParking
export const updatedReceive = fetchFleetRecoverySlice.actions.updatedReceive;
export const updatedHandover = fetchFleetRecoverySlice.actions.updatedHandover;
export const updatedRecovery = fetchFleetRecoverySlice.actions.updatedRecovery;
export const updatedProcurement = fetchFleetRecoverySlice.actions.updatedProcurement;
export const updatedParking = fetchFleetRecoverySlice.actions.updatedParking;

export const getReceive = fetchFleetRecoverySlice.actions.getReceive;
export const getHandover = fetchFleetRecoverySlice.actions.getHandover;
export const getRecovery = fetchFleetRecoverySlice.actions.getRecovery;
export const getProcurement = fetchFleetRecoverySlice.actions.getProcurement;
export const getParking = fetchFleetRecoverySlice.actions.getParking;

export const FleetManagemntAllDashboardDetails = FleetManagemntAllDashboardSlice.reducer;
export const FetchFleetRecoveryDetails = fetchFleetRecoverySlice.reducer;
